import React, { useState } from 'react';

const countries = [
  { code: '+36', name: 'Magyarország', flag: '🇭🇺' },
  { code: '+43', name: 'Ausztria', flag: '🇦🇹' },
  { code: '+49', name: 'Németország', flag: '🇩🇪' },
  { code: '+33', name: 'Franciaország', flag: '🇫🇷' },
  { code: '+39', name: 'Olaszország', flag: '🇮🇹' },
  { code: '+44', name: 'Egyesült Királyság', flag: '🇬🇧' },
  { code: '+1', name: 'USA/Kanada', flag: '🇺🇸' },
  { code: '+41', name: 'Svájc', flag: '🇨🇭' },
  { code: '+31', name: 'Hollandia', flag: '🇳🇱' },
  { code: '+32', name: 'Belgium', flag: '🇧🇪' },
  { code: '+34', name: 'Spanyolország', flag: '🇪🇸' },
  { code: '+351', name: 'Portugália', flag: '🇵🇹' },
  { code: '+420', name: 'Csehország', flag: '🇨🇿' },
  { code: '+421', name: 'Szlovákia', flag: '🇸🇰' },
  { code: '+48', name: 'Lengyelország', flag: '🇵🇱' },
  { code: '+40', name: 'Románia', flag: '🇷🇴' },
  { code: '+385', name: 'Horvátország', flag: '🇭🇷' },
  { code: '+386', name: 'Szlovénia', flag: '🇸🇮' },
  { code: '+381', name: 'Szerbia', flag: '🇷🇸' },
];

const PhoneInput = ({ value, onChange, placeholder, className, required = true, ...props }) => {
  const [countryCode, setCountryCode] = useState('+36');
  const [phoneNumber, setPhoneNumber] = useState('');

  // Parse existing value if provided
  React.useEffect(() => {
    if (value && value !== `${countryCode}${phoneNumber}`) {
      const country = countries.find(c => value.startsWith(c.code));
      if (country) {
        setCountryCode(country.code);
        setPhoneNumber(value.substring(country.code.length));
      } else {
        setPhoneNumber(value);
      }
    }
  }, [value]);

  const handleCountryChange = (e) => {
    const newCountryCode = e.target.value;
    setCountryCode(newCountryCode);
    const fullNumber = `${newCountryCode}${phoneNumber}`;
    onChange({ target: { name: props.name, value: fullNumber } });
  };

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;
    
    // Remove any non-digit characters except spaces and dashes
    inputValue = inputValue.replace(/[^\d\s-]/g, '');
    
    // Limit length based on country code
    const maxLength = countryCode === '+36' ? 11 : 15;
    if (inputValue.length > maxLength) {
      inputValue = inputValue.substring(0, maxLength);
    }

    setPhoneNumber(inputValue);
    const fullNumber = `${countryCode}${inputValue}`;
    onChange({ target: { name: props.name, value: fullNumber } });
  };

  const validatePhoneNumber = () => {
    if (!phoneNumber.trim()) return false;
    
    // Basic validation - at least 7 digits for any country
    const digitsOnly = phoneNumber.replace(/[\s-]/g, '');
    if (digitsOnly.length < 7) return false;
    
    // Country-specific validation
    if (countryCode === '+36') {
      // Hungarian phone numbers: should be 9 digits after country code
      return digitsOnly.length === 9;
    }
    
    // For other countries, accept 7-15 digits
    return digitsOnly.length >= 7 && digitsOnly.length <= 15;
  };

  const isValid = validatePhoneNumber();

  return (
    <div className="flex gap-2">
      <select
        value={countryCode}
        onChange={handleCountryChange}
        className="rounded px-3 py-2 bg-white/70 text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#e31937] font-medium text-[1.07rem] min-w-[120px]"
        required={required}
      >
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {country.flag} {country.code}
          </option>
        ))}
      </select>
      <input
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneChange}
        placeholder={placeholder || "30 123 4567"}
        className={`flex-1 rounded px-3 py-2 bg-white/70 text-gray-900 border focus:outline-none focus:ring-2 focus:ring-[#e31937] font-medium text-[1.07rem] ${
          phoneNumber && !isValid 
            ? 'border-red-500 focus:ring-red-500' 
            : 'border-gray-300'
        } ${className || ''}`}
        required={required}
        {...props}
      />
      {phoneNumber && !isValid && (
        <div className="absolute mt-12 text-red-500 text-sm">
          Érvénytelen telefonszám formátum
        </div>
      )}
    </div>
  );
};

export default PhoneInput;
